import axios from "axios";
import { attachRefresh } from "./refresh";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, withCredentials: true });
attachRefresh(http, () => {
  if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
});

export const api = {
  // dashboard
  dashboard: (year, month) => http.get("/dashboard", { params: { year, month: month || undefined } }).then((r) => r.data),
  // events
  listEvents: (year) => http.get("/events", { params: { year } }).then((r) => r.data),
  createEvent: (data) => http.post("/events", data).then((r) => r.data),
  updateEvent: (id, data) => http.put(`/events/${id}`, data).then((r) => r.data),
  deleteEvent: (id) => http.delete(`/events/${id}`).then((r) => r.data),
  addEventPayment: (id, data) => http.post(`/events/${id}/payments`, data).then((r) => r.data),
  deleteEventPayment: (id, pid) => http.delete(`/events/${id}/payments/${pid}`).then((r) => r.data),
  // expenses
  listExpenses: (year) => http.get("/expenses", { params: { year } }).then((r) => r.data),
  createExpense: (data) => http.post("/expenses", data).then((r) => r.data),
  updateExpense: (id, data) => http.put(`/expenses/${id}`, data).then((r) => r.data),
  deleteExpense: (id) => http.delete(`/expenses/${id}`).then((r) => r.data),
  setExpensePaid: (id, pagato) => http.put(`/expenses/${id}/pagato`, { pagato }).then((r) => r.data),
  setStaffCashPaid: (id, paid, month, kind) => http.put(`/staff/${id}/cash-paid`, { paid, month, kind }).then((r) => r.data),
  staffFixedMonths: () => http.get("/staff/fixed-months").then((r) => r.data),
  staffCashMonths: () => http.get("/staff/cash-months").then((r) => r.data),
  getCassaSettings: () => http.get("/settings/cassa").then((r) => r.data),
  setCassaSettings: (cassa_srl_opening) => http.put("/settings/cassa", { cassa_srl_opening }).then((r) => r.data),
  // staff
  listStaff: () => http.get("/staff").then((r) => r.data),
  staffSummary: () => http.get("/staff/summary").then((r) => r.data),
  createStaff: (data) => http.post("/staff", data).then((r) => r.data),
  updateStaff: (id, data) => http.put(`/staff/${id}`, data).then((r) => r.data),
  deleteStaff: (id) => http.delete(`/staff/${id}`).then((r) => r.data),
  // departments / aree
  listDepartments: () => http.get("/departments").then((r) => r.data),
  createDepartment: (data) => http.post("/departments", data).then((r) => r.data),
  updateDepartment: (id, data) => http.put(`/departments/${id}`, data).then((r) => r.data),
  deleteDepartment: (id) => http.delete(`/departments/${id}`).then((r) => r.data),
  // expense categories
  listExpenseCategories: () => http.get("/expense-categories").then((r) => r.data),
  createExpenseCategory: (data) => http.post("/expense-categories", data).then((r) => r.data),
  deleteExpenseCategory: (id) => http.delete(`/expense-categories/${id}`).then((r) => r.data),
  // event types
  listEventTypes: () => http.get("/event-types").then((r) => r.data),
  createEventType: (data) => http.post("/event-types", data).then((r) => r.data),
  deleteEventType: (id) => http.delete(`/event-types/${id}`).then((r) => r.data),
  // staff forecast
  staffForecast: (month) => http.get("/staff/forecast", { params: { month } }).then((r) => r.data),
  // inventory
  listInventory: () => http.get("/inventory").then((r) => r.data),
  createInventory: (data) => http.post("/inventory", data).then((r) => r.data),
  updateInventory: (id, data) => http.put(`/inventory/${id}`, data).then((r) => r.data),
  deleteInventory: (id) => http.delete(`/inventory/${id}`).then((r) => r.data),
  // chat
  chatHistory: (session_id = "betti-main") => http.get("/chat/history", { params: { session_id } }).then((r) => r.data),
  clearChat: (session_id = "betti-main") => http.delete("/chat/history", { params: { session_id } }).then((r) => r.data),
  seed: () => http.post("/seed").then((r) => r.data),
  // access management
  grantAccess: (id, data) => http.post(`/staff/${id}/access`, data).then((r) => r.data),
  revokeAccess: (id) => http.delete(`/staff/${id}/access`).then((r) => r.data),
  resetStaffPassword: (id) => http.post(`/staff/${id}/reset-password`).then((r) => r.data),
  accessLastLogin: () => http.get("/access-last-login").then((r) => r.data),
  // vehicles
  listVehicles: () => http.get("/vehicles").then((r) => r.data),
  vehiclesKmSummary: () => http.get("/vehicles/km-summary").then((r) => r.data),
  createVehicle: (data) => http.post("/vehicles", data).then((r) => r.data),
  updateVehicle: (id, data) => http.put(`/vehicles/${id}`, data).then((r) => r.data),
  deleteVehicle: (id) => http.delete(`/vehicles/${id}`).then((r) => r.data),
  // reports
  listReports: () => http.get("/reports").then((r) => r.data),
  reportExpenses: () => http.get("/report-expenses").then((r) => r.data),
  listIncomes: () => http.get("/incomes").then((r) => r.data),
  createIncome: (data) => http.post("/incomes", data).then((r) => r.data),
  deleteIncome: (id) => http.delete(`/incomes/${id}`).then((r) => r.data),
  getReport: (id) => http.get(`/reports/${id}`).then((r) => r.data),
  createReport: (data) => http.post("/reports", data).then((r) => r.data),
  updateReport: (id, data) => http.put(`/reports/${id}`, data).then((r) => r.data),
  deleteReport: (id) => http.delete(`/reports/${id}`).then((r) => r.data),
  closeReport: (id, chiuso) => http.put(`/reports/${id}/close`, { chiuso }).then((r) => r.data),
  // tech self-service reports
  techEvents: () => http.get("/tech/events").then((r) => r.data),
  techStaff: () => http.get("/tech/staff").then((r) => r.data),
  techVehicles: () => http.get("/tech/vehicles").then((r) => r.data),
  techGetReport: (eventId) => http.get(`/tech/report/${eventId}`).then((r) => r.data),
  techSaveReport: (data) => http.post("/tech/report", data).then((r) => r.data),
  techCreateEvent: (data) => http.post("/tech/event", data).then((r) => r.data),
  // rimborsi tecnici
  listRimborsi: () => http.get("/rimborsi").then((r) => r.data),
  payRimborso: (spesaId, paid, metodo) => http.post("/rimborsi/pay", { spesa_id: spesaId, paid, metodo }).then((r) => r.data),
  // ranking
  staffRanking: () => http.get("/staff/ranking").then((r) => r.data),
  vatPosition: (year) => http.get("/vat-position", { params: { year } }).then((r) => r.data),
  timbraturaToday: () => http.get("/timbrature/today").then((r) => r.data),
  clockIn: (geo) => http.post("/timbrature/clock-in", geo || {}).then((r) => r.data),
  clockOut: (geo) => http.post("/timbrature/clock-out", geo || {}).then((r) => r.data),
  saveMandatino: (data) => http.put("/timbrature/mandatino", data).then((r) => r.data),
  listTimbrature: (params) => http.get("/timbrature", { params }).then((r) => r.data),
};
